module.exports = __webpack_public_path__ + "static/media/logo-tp.92f907e4.png";